import React from 'react' 

export const Help: React.FC = () => {
    return (
        <h1>Napoveda</h1>
    )
}